// Frontend entry point - will be implemented later
console.log('Frontend bundle loaded');